export const SHOP_API_BASE = "https://onesystem.asherjewels.com.ph/api/shop";
export const SHOP_IMAGE_BASE = "https://onesystem.asherjewels.com.ph/";

export async function fetchShopJson(path) {
  const response = await fetch(`${SHOP_API_BASE}${path}`, {
    method: "GET",
    mode: "cors",
    cache: "no-store",
    referrerPolicy: "strict-origin-when-cross-origin",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Shop API request failed: ${response.status}`);
  }

  return response.json();
}
